import template from 'component/teaser_group/template/large.tmpl'
import GroupView from 'component/teaser_group/small'

const GroupLargeView = GroupView.extend({
    template,
})

export default GroupLargeView
